import React from "react";
import PropTypes from "prop-types";
import { StepItem } from "../StepItem";

export function StepList(props) {
  const renderStep = (step) => (
    <StepItem
      addNote={props.addNote}
      stepId={step.stepId}
      key={`${props.taskId}_${step.stepId}`}
      ariaLabel={step.ariaLabel}
      complete={step.complete}
      current={step.current}
      notes={step.notes}
      task={step.task}
    />
  );

  return <div className={props.className}>{props.steps.map(renderStep)}</div>;
}

StepList.propTypes = {
  /**
   * Index of th  task
   */
  taskId: PropTypes.number,
  /**
   * className for component
   */
  className: PropTypes.string,
  /**
   * List of steps
   */
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * UniqueId for the step
       */
      stepId: PropTypes.number,
      /**
       * ariaLabel for the task
       */
      ariaLabel: PropTypes.string,
      /**
       * boolean to set if step complete
       */
      complete: PropTypes.bool,
      /**
       * boolean to set if the step is the active one
       */
      current: PropTypes.bool,
      /**
       * List of notes associated with step
       */
      notes: PropTypes.arrayOf(PropTypes.string),
      /**
       * description of task
       */
      task: PropTypes.string,
    })
  ),
  /**
   * Function to add new note to a step
   */
  addNote: PropTypes.func,
};

StepList.defaultProps = {
  className: "progressTracker_stepBlock",
  steps: [],
};
